<template>
  <div>
    <header-component />
    <!-- Hero / first section -->
    <section
      v-if="isSalon"
      class="w-100 d-inline-block apply-hero apply-hero-salon-cover"
      :style="salonHeroCoverStyle"
      role="img"
      :aria-label="heroImageAlt"
    >
      <div class="container autoContent">
        <div class="row py-5">
          <div class="col-xl-7 col-lg-7 col-md-9 col-12">
            <div class="apply-hero-salon-cover-content">
              <h1 class="mb-3 filson-black-family text-capitalize apply-hero-title">
                {{ heroTitle }}
              </h1>
              <p class="mb-4 text-size-14 text-black inter-regular-family text-full-13 apply-hero-desc">
                {{ heroDescription }}
              </p>
              <router-link
                class="text-white text-size-14 d-inline-block border-0 bg-orange inter-semi-bold text-uppercase text-full-11 apply-hero-cta"
                :to="heroCtaTo"
              >
                {{ heroCtaText }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <span class="apply-hero-salon-heart" aria-hidden="true"></span>
      <span class="apply-hero-salon-heart apply-hero-salon-heart-2" aria-hidden="true"></span>
    </section>
    <section v-else class="w-100 d-inline-block apply-hero">
      <div class="container autoContent">
        <div class="row align-items-center">
          <div class="col-xl-6 col-lg-6 col-md-7 col-12 order-2 order-md-1">
            <h1 class="mb-3 filson-black-family text-capitalize apply-hero-title">
              {{ heroTitle }}
            </h1>
            <p class="mb-4 text-size-14 text-black inter-regular-family text-full-13 apply-hero-desc">
              {{ heroDescription }}
            </p>
            <router-link
              class="text-white text-size-14 d-inline-block border-0 bg-orange inter-semi-bold text-uppercase text-full-11 apply-hero-cta"
              :to="heroCtaTo"
            >
              {{ heroCtaText }}
            </router-link>
          </div>

          <div class="col-xl-6 col-lg-6 col-md-5 col-12 order-1 order-md-2 mb-4 mb-md-0">
            <div class="apply-hero-media ms-md-auto">
              <img
                class="w-100 h-100"
                style="object-fit: cover;"
                v-lazy="groomerHeroImageSrc"
                :alt="heroImageAlt"
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Section 2 -->
    <section class="w-100 d-inline-block apply-setup">
      <div class="container autoContent">
        <div class="row">
          <div class="col-12 text-center py-5">
            <template v-if="isSalon">
              <h2 class="mb-2 filson-black-family apply-setup-title apply-salon-setup-title">
                {{ salonChooseHeading }}
              </h2>
              <p class="mb-4 text-size-14 text-black inter-regular-family text-full-13 apply-setup-subtitle apply-salon-setup-subtitle">
                {{ salonChooseText }}
              </p>

              <div class="row g-3 justify-content-center apply-salon-setup-grid">
                <div class="col-xl-5 col-lg-6 col-md-6 col-12">
                  <div class="apply-salon-setup-col">
                    <div v-for="b in salonBenefitsLeft" :key="b.id" class="apply-salon-benefit apply-salon-benefit--icon-right">
                      <div class="apply-salon-benefit-icon">
                        <img v-if="b.iconImage" class="apply-salon-benefit-icon-img" :src="b.iconImage" alt="">
                        <i v-else :class="b.icon" aria-hidden="true"></i>
                      </div>
                      <div class="apply-salon-benefit-body">
                        <div class="apply-salon-benefit-title inter-bold-family text-black">
                          {{ b.title }}
                        </div>
                        <div class="apply-salon-benefit-desc inter-regular-family text-black">
                          {{ b.description }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-5 col-lg-6 col-md-6 col-12">
                  <div class="apply-salon-setup-col">
                    <div v-for="b in salonBenefitsRight" :key="b.id" class="apply-salon-benefit apply-salon-benefit--icon-left">
                      <div class="apply-salon-benefit-icon">
                        <img v-if="b.iconImage" class="apply-salon-benefit-icon-img" :src="b.iconImage" alt="">
                        <i v-else :class="b.icon" aria-hidden="true"></i>
                      </div>
                      <div class="apply-salon-benefit-body">
                        <div class="apply-salon-benefit-title inter-bold-family text-black">
                          {{ b.title }}
                        </div>
                        <div class="apply-salon-benefit-desc inter-regular-family text-black">
                          {{ b.description }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-else>
              <h2 class="mb-2 filson-black-family apply-setup-title">
                PICK YOUR LUSHGROOM SETUP
              </h2>
              <p class="mb-4 text-size-14 text-black inter-regular-family text-full-13 apply-setup-subtitle">
                However you work — from home, in a salon, or on the go — LushGroom is built to support your style and grow your
                business.
              </p>

              <div class="row g-3 justify-content-center">
                <div
                  v-for="card in setupCards"
                  :key="card.id"
                  class="col-xl-3 col-lg-3 col-md-6 col-12"
                >
                  <div class="apply-setup-card h-100">
                    <div class="apply-setup-icon">
                      <img
                        v-if="card.iconImage"
                        class="apply-setup-icon-img"
                        :src="card.iconImage"
                        alt=""
                      >
                      <i v-else :class="card.icon" aria-hidden="true"></i>
                    </div>
                    <h3 class="mb-2 text-size-14 text-black inter-bold-family text-full-13 text-uppercase">
                      {{ card.title }}
                    </h3>
                    <p class="mb-3 text-size-12 text-black inter-regular-family text-full-12 apply-setup-desc">
                      {{ card.description }}
                    </p>
                    <p class="mb-0 text-size-11 text-black inter-bold-family text-full-11 text-uppercase apply-setup-foot">
                      {{ card.footer }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <div class="mt-4">
              <router-link
                class="text-white text-size-14 d-inline-block border-0 bg-orange inter-semi-bold text-uppercase text-full-11 apply-setup-cta"
                :to="joinCtaTo"
              >
                JOIN LUSHGROOM
              </router-link>
              <div class="text-size-10 text-black inter-regular-family text-full-10 mt-2 apply-setup-cta-sub">
                START GROWING TODAY
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Section 3 -->
    <section class="w-100 d-inline-block apply-why">
      <div class="container autoContent">
        <div class="row align-items-center py-5">
          <template v-if="isSalon">
            <div class="col-xl-6 col-lg-6 col-md-6 col-12 order-2 order-md-1">
              <h2 class="mb-2 filson-black-family apply-salon-pay-title">
                {{ salonPaymentHeading }}
              </h2>
              <p class="mb-4 text-size-14 text-black inter-regular-family text-full-13 apply-salon-pay-subtitle">
                {{ salonPaymentText }}
              </p>

              <ul class="apply-salon-pay-list ps-0 mb-0">
                <li v-for="b in salonPaymentsBenefits" :key="b.id" class="apply-salon-pay-item">
                  <span class="apply-salon-pay-bullet" aria-hidden="true">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </span>
                  <div class="apply-salon-pay-text">
                    <div class="apply-salon-pay-item-title inter-bold-family text-black">
                      {{ b.title }}
                    </div>
                    <div class="apply-salon-pay-item-desc inter-regular-family text-black">
                      {{ b.description }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-4 mb-md-0 order-1 order-md-2">
              <div class="apply-salon-pay-visual ms-md-auto">
                <div
                  class="apply-salon-pay-image"
                  :style="salonPaymentsPhotoStyle"
                  role="img"
                  aria-label="Easy payments for salons"
                ></div>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
              <div class="apply-why-visual">
                <div
                  class="apply-why-image"
                  :style="groomerWhyJoinImageStyle"
                  role="img"
                  aria-label="Why join LushGroom"
                ></div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-12">
              <h2 class="mb-2 filson-black-family apply-why-title">
                {{ groomerWhyJoinHeading }}
              </h2>
              <p class="mb-4 text-size-14 text-black inter-regular-family text-full-13 apply-why-subtitle">
                {{ groomerWhyJoinIntro }}
              </p>

              <ul class="apply-why-list ps-0 mb-0">
                <li v-for="(item, idx) in whyItems" :key="item.id" class="apply-why-item">
                  <div class="apply-why-num">{{ String(idx + 1).padStart(2, '0') }}</div>
                  <div class="apply-why-text">
                    <div class="apply-why-item-title inter-bold-family text-black">
                      {{ item.title }}
                    </div>
                    <div class="apply-why-item-desc inter-regular-family text-black">
                      {{ item.description }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </section>
    <!-- Section 4 -->
    <section class="w-100 d-inline-block apply-say">
      <div class="container autoContent">
        <div class="row">
          <div class="col-12 text-center py-5">
            <template v-if="isSalon">
              <h2 class="mb-2 filson-black-family apply-salon-spot-title">
                {{ salonGrowHeading }}
              </h2>
              <p class="mb-4 text-size-14 text-black inter-regular-family text-full-13 apply-salon-spot-subtitle">
                {{ salonGrowText }}
              </p>

              <div class="row g-3 justify-content-center apply-salon-spot-grid">
                <div
                  v-for="c in salonSpotlightCards"
                  :key="c.id"
                  class="col-xl-3 col-lg-3 col-md-6 col-12"
                >
                  <div class="apply-salon-spot-card h-100">
                    <div class="apply-salon-spot-icon">
                      <img v-if="c.iconImage" class="apply-salon-spot-icon-img" :src="c.iconImage" alt="">
                      <i v-else :class="c.icon" aria-hidden="true"></i>
                    </div>
                    <div class="apply-salon-spot-card-title inter-bold-family text-black text-uppercase">
                      {{ c.title }}
                    </div>
                    <div class="apply-salon-spot-card-desc inter-regular-family text-black">
                      {{ c.description }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <router-link
                  class="text-white text-size-14 d-inline-block border-0 bg-orange inter-semi-bold text-uppercase text-full-11 apply-setup-cta"
                  :to="joinCtaTo"
                >
                  JOIN LUSHGROOM
                </router-link>
              </div>
            </template>

            <template v-else>
              <h2 class="mb-4 filson-black-family apply-say-title">
                What our Groomers say
              </h2>

              <div class="row g-3 justify-content-center">
                <div
                  v-for="t in groomerTestimonials"
                  :key="t.id"
                  class="col-xl-4 col-lg-5 col-md-6 col-12"
                >
                  <div class="apply-say-card h-100 text-start">
                    <p class="mb-4 text-size-12 inter-regular-family text-black text-full-12 apply-say-quote">
                      {{ t.quote }}
                    </p>

                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center gap-2">
                        <div class="apply-say-avatar" :aria-label="t.name">
                          {{ t.initials }}
                        </div>
                        <div class="lh-sm">
                          <div class="text-size-12 inter-bold-family text-black text-full-12 text-uppercase">
                            {{ t.name }}
                          </div>
                          <div class="text-size-10 inter-regular-family text-black text-full-10 apply-say-role">
                            {{ t.role }}
                          </div>
                        </div>
                      </div>

                      <div class="apply-say-stars" :aria-label="`Rating ${t.rating} out of 5`">
                        <i
                          v-for="i in 5"
                          :key="`${t.id}-s-${i}`"
                          class="fa"
                          :class="i <= t.rating ? 'fa-star' : 'fa-star-o'"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

          </div>
        </div>
      </div>
    </section>
    <!-- Salon-only: testimonials (inserted before FAQ) -->
    <section v-if="isSalon" class="w-100 d-inline-block apply-salon-say">
      <div class="container autoContent">
        <div class="row">
          <div class="col-12 text-center py-5">
            <h2 class="mb-4 filson-black-family apply-salon-say-title">
              What our Groomers say
            </h2>

            <div class="row g-3 justify-content-center">
              <div
                v-for="t in salonTestimonials"
                :key="t.id"
                class="col-xl-4 col-lg-5 col-md-6 col-12"
              >
                <div class="apply-salon-say-card h-100 text-start">
                  <p class="mb-4 text-size-12 inter-regular-family text-black text-full-12 apply-salon-say-quote">
                    {{ t.quote }}
                  </p>

                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center gap-2">
                      <div class="apply-salon-say-avatar" :aria-label="t.name">
                        {{ t.initials }}
                      </div>
                      <div class="lh-sm">
                        <div class="text-size-12 inter-bold-family text-black text-full-12 text-uppercase">
                          {{ t.name }}
                        </div>
                        <div class="text-size-10 inter-regular-family text-black text-full-10 apply-salon-say-role">
                          {{ t.role }}
                        </div>
                      </div>
                    </div>

                    <div class="apply-salon-say-stars" :aria-label="`Rating ${t.rating} out of 5`">
                      <i
                        v-for="i in 5"
                        :key="`${t.id}-s-${i}`"
                        class="fa"
                        :class="i <= t.rating ? 'fa-star' : 'fa-star-o'"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    <!-- Section 5: FAQ (same UI on groomer + salon) -->
    <div v-if="isGroomer || isSalon" class="w-100 d-inline-block py-5 apply-faq-groomer">
      <div class="container autoContent">
        <div class="row mb-4">
          <div class="col-12 text-center">
            <p class="mb-2 text-uppercase nav-color fw-bold filson-black-family" style="letter-spacing: 1px; color: #f8721f">
              FAQ
            </p>
            <h2 class="text-black fw-bold filson-black-family text-uppercase margin-bottom-2" style="font-size: 32px">
              Frequently Asked Questions
            </h2>
          </div>
        </div>

        <div class="row g-3" id="applyFaqAccordion">
          <div class="col-lg-6 col-12" v-for="(faqCol, colIdx) in applyFaqColumns" :key="`apply-faq-col-${colIdx}`">
            <div
              v-for="(faqItem, faqIdx) in faqCol"
              :key="`apply-faq-${colIdx}-${faqIdx}`"
              class="w-100 d-inline-block pets-collapse bg-white rounded-3 shadow-sm px-4 py-3 border-0"
              style="margin-bottom: 16px"
            >
              <a
                class="family-filson-bold text-black text-size-14 fw-bold w-100 d-flex align-items-center text-decoration-none"
                href="javascript:void(0)"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapseFaqApply' + faqItem._idx"
                :aria-expanded="faqItem._idx === 0"
                :aria-controls="'collapseFaqApply' + faqItem._idx"
              >
                <i class="fa fa-check-circle-o nav-color me-3" style="font-size: 20px" aria-hidden="true"></i>
                <span class="text-full-14 text-size-14">{{ faqItem.question }}</span>
              </a>
              <div
                :id="'collapseFaqApply' + faqItem._idx"
                class="collapse mt-3 ms-4 ps-2"
                :class="{ show: faqItem._idx === 0 }"
                data-bs-parent="#applyFaqAccordion"
              >
                <p class="mb-0 text-size-14 text-muted family-inter-light text-lh-large text-full-13">
                  {{ faqItem.answer }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End bar -->
    <div class="w-100 d-inline-block bg-orange">
      <div class="container autoContent">
        <div class="row margin-top-1 margin-bottom-0">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0">
              <li class="float-start margin-right-2">
                <router-link class="text-black text-size-14 medium-family text-full-13" to="/">
                  <i class="fa fa-home text-black" aria-hidden="true"></i>
                  Home /
                </router-link>
              </li>
              <li class="float-start">
                <router-link class="text-black text-size-14 medium-family text-full-13" to="/services/">
                  Services
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'ApplyPartnerPage',
  components: {
    headerComponent,
    footerComponent,
  },
  data() {
    return {
      groomerPage: null,
      salonPage: null,
    };
  },
  mounted() {
    this.fetchGroomerPage();
    this.fetchSalonPage();
  },
  watch: {
    '$route.path'() {
      if (this.isGroomer) this.fetchGroomerPage();
      if (this.isSalon) this.fetchSalonPage();
    },
  },
  computed: {
    pageHeading() {
      return this.$route.meta.pageHeading || 'Apply';
    },
    isSalon() {
      return (this.$route.path || '').toLowerCase().includes('apply-as-salon');
    },
    isGroomer() {
      return (this.$route.path || '').toLowerCase().includes('apply-as-groomer');
    },
    heroTitle() {
      if (this.isSalon) {
        const h = this.salonPage?.main_heading;
        return h && String(h).trim() ? h : 'Turn LushGroom Into Your Salon’s #1 Client Source';
      }
      const h = this.groomerPage?.main_heading;
      return h && String(h).trim() ? h : 'Grow Your Grooming Business With LushGroom';
    },
    heroDescription() {
      if (this.isSalon) {
        const t = this.salonPage?.main_text;
        return t && String(t).trim()
          ? t
          : 'Set your own prices, attract quality customers, and enjoy guaranteed prepaid bookings — all in one platform.';
      }
      const t = this.groomerPage?.main_text;
      return t && String(t).trim()
        ? t
        : 'Whether you offer in-home services, run a mobile van, manage a salon, or work from a home studio — LushGroom connects you with real, paying customers and ensures secure, prepaid bookings.';
    },
    groomerHeroImageSrc() {
      const path = this.groomerPage?.main_image;
      if (path && String(path).trim()) {
        return this.$getImageUrl(path);
      }
      return require('@/assets/images/groomer-first.png');
    },
    groomerWhyJoinHeading() {
      const h = this.groomerPage?.why_join_heading;
      return h && String(h).trim() ? h : 'Why Join LushGroom?';
    },
    groomerWhyJoinIntro() {
      const t = this.groomerPage?.why_join_text;
      return t && String(t).trim()
        ? t
        : 'Grow your grooming business with reliable income, more clients, and total flexibility — all without the stress of marketing or chasing payments.';
    },
    heroCtaText() {
      return this.isSalon ? 'Join LushGroom Today' : 'Start Your LushGroom Journey Today';
    },
    heroCtaTo() {
      return this.isSalon ? '/apply-as-salon/join?joinType=salon' : '/apply-as-salon/join?joinType=groomer';
    },
    heroImageAlt() {
      return this.isSalon ? 'Apply as Salon' : 'Apply as Groomer';
    },
    joinCtaTo() {
      return this.isSalon ? '/apply-as-salon/join?joinType=salon' : '/apply-as-salon/join?joinType=groomer';
    },
    salonChooseHeading() {
      const h = this.salonPage?.choose_us_heading;
      return h && String(h).trim() ? h : 'WHY LEADING SALONS CHOOSE LUSHGROOM';
    },
    salonChooseText() {
      const t = this.salonPage?.choose_us_text;
      return t && String(t).trim()
        ? t
        : 'We give you the tools and exposure to grow faster — while you stay fully in control of your business, brand, and pricing.';
    },
    salonPaymentHeading() {
      const h = this.salonPage?.payment_heading;
      return h && String(h).trim() ? h : 'Easy Payments. Total Control.';
    },
    salonPaymentText() {
      const t = this.salonPage?.payment_text;
      return t && String(t).trim()
        ? t
        : 'Get paid with confidence — no subscriptions, no hidden fees, just simple and transparent earnings.';
    },
    salonGrowHeading() {
      const h = this.salonPage?.grow_with_heading;
      return h && String(h).trim() ? h : 'GROW WITH LUSHGROOM — YOUR BRAND, YOUR SPOTLIGHT';
    },
    salonGrowText() {
      const t = this.salonPage?.grow_with_text;
      return t && String(t).trim()
        ? t
        : "You've built your reputation with care. With LushGroom, you grow your business without compromising your identity.";
    },
    salonHeroStyle() {
      const bg = require('@/assets/images/apply-salon-hero.png');
      return {
        backgroundImage: `linear-gradient(90deg, rgba(245,246,247,1) 0%, rgba(245,246,247,0.96) 35%, rgba(245,246,247,0.65) 55%, rgba(245,246,247,0) 70%), url(${bg})`,
      };
    },
    salonHeroCoverStyle() {
      const path = this.salonPage?.main_cover_img;
      let bg;
      if (path && String(path).trim()) {
        bg = this.$getImageUrl(path);
      } else {
        const mod = require('@/assets/images/main-cover.png');
        bg = mod?.default || mod;
      }
      return {
        background: `linear-gradient(90deg, rgba(245,246,247,0.98) 0%, rgba(245,246,247,0.92) 36%, rgba(245,246,247,0.55) 58%, rgba(245,246,247,0) 74%), url("${bg}") center right / cover no-repeat`,
      };
    },
    salonPaymentsPhotoStyle() {
      const path = this.salonPage?.payment_img;
      let src;
      if (path && String(path).trim()) {
        src = this.$getImageUrl(path);
      } else {
        const mod = require('@/assets/images/easy-payment.png');
        src = mod?.default || mod;
      }
      return {
        background: `url("${src}") 86% 50% / cover no-repeat`,
      };
    },
    groomerWhyJoinImageStyle() {
      const path = this.groomerPage?.why_join_image;
      let src;
      if (path && String(path).trim()) {
        src = this.$getImageUrl(path);
      } else {
        const mod = require('@/assets/images/join-us-img.png');
        src = mod?.default || mod;
      }
      return {
        background: `url("${src}") center / contain no-repeat`,
      };
    },
    setupCards() {
      const defaults = [
        {
          id: 'in-home',
          icon: 'fa fa-home',
          iconImage: (() => {
            const m = require('@/assets/images/service-1.png');
            return m?.default || m;
          })(),
          title: 'IN-HOME SERVICE',
          description:
            'Deliver grooming right at your client’s location so you can serve more customers. LushGroom updates a service fee. Clients value the added convenience and reliability.',
          footer: 'ALL BOOKINGS ARE PREPAID AND CUSTOMERS PAY PEACE OF MIND.',
        },
        {
          id: 'mobile-van',
          icon: 'fa fa-truck',
          iconImage: (() => {
            const m = require('@/assets/images/service-2.png');
            return m?.default || m;
          })(),
          title: 'MOBILE VAN',
          description:
            'Take your grooming business anywhere. Keep your van moving while LushGroom handles customer demand. It’s free, earn more, and build loyal clients with smart surge pricing while we help keep your calendar scheduled full.',
          footer: 'EVERY BOOKING IS PREPAID AND SECURED.',
        },
        {
          id: 'home-studio',
          icon: 'fa fa-building',
          iconImage: (() => {
            const m = require('@/assets/images/service-3.png');
            return m?.default || m;
          })(),
          title: 'HOME STUDIO',
          description:
            'Work from the comfort of your own space with minimal overhead. Let your pricing and brand speak. Customers trust in hygiene and quality, plus fair earnings during busy periods.',
          footer: 'PREPAID BOOKINGS ENSURE YOU TAKE TIME AWAY AS EXPECTED.',
        },
        {
          id: 'salon',
          icon: 'fa fa-scissors',
          iconImage: (() => {
            const m = require('@/assets/images/service-4.png');
            return m?.default || m;
          })(),
          title: 'SALON',
          description:
            'Continue running your salon your way while LushGroom connects you with more clients. Take advantage of dynamic pricing during high-demand hours.',
          footer: 'ALL APPOINTMENTS ARE PREPAID AND GUARANTEED.',
        },
      ];
      const p = this.groomerPage;
      if (!p) return defaults;

      const footerKeys = ['service_text_12', 'service_text_22', 'service_text_32', 'service_text_42'];
      return [1, 2, 3, 4].map((n, idx) => {
        const d = defaults[idx];
        const iconPath = p[`service_icon_${n}`];
        const title = p[`service_heading_${n}`];
        const desc = p[`service_text_${n}`];
        const footer = p[footerKeys[idx]];
        return {
          id: d.id,
          icon: d.icon,
          iconImage: iconPath && String(iconPath).trim() ? this.$getImageUrl(iconPath) : null,
          title: title && String(title).trim() ? title : d.title,
          description: desc && String(desc).trim() ? desc : d.description,
          footer: footer && String(footer).trim() ? footer : d.footer,
        };
      });
    },
    salonBenefits() {
      const defaults = [
        {
          id: 'clients',
          icon: 'fa fa-users',
          iconImage: (() => { const m = require('@/assets/images/why-choose-1.png'); return m?.default || m; })(),
          title: 'Attract More Clients',
          description: 'Connect with a growing network of pet owners actively searching for premium grooming services near you.',
        },
        {
          id: 'brand',
          icon: 'fa fa-id-badge',
          iconImage: (() => { const m = require('@/assets/images/why-choose-2.png'); return m?.default || m; })(),
          title: 'Your Brand, Your Identity',
          description: 'Operate under your own salon name and branding. LushGroom works quietly in the background to drive you growth.',
        },
        {
          id: 'fees',
          icon: 'fa fa-tag',
          iconImage: (() => { const m = require('@/assets/images/why-choose-3.png'); return m?.default || m; })(),
          title: 'No Subscription Fees',
          description: 'Join at no cost. We simply take a small commission per completed booking.',
        },
        {
          id: 'prepaid',
          icon: 'fa fa-shield',
          iconImage: (() => { const m = require('@/assets/images/why-choose-4.png'); return m?.default || m; })(),
          title: 'Guaranteed Prepaid Appointments',
          description: 'Every booking is paid in advance, protecting you from cancellations and no-shows.',
        },
        {
          id: 'schedule',
          icon: 'fa fa-calendar',
          iconImage: (() => { const m = require('@/assets/images/why-choose-5.png'); return m?.default || m; })(),
          title: 'Maximize Your Schedule',
          description: 'Fill last-minute gaps and slow periods with smart, targeted bookings that keep your calendar consistently busy.',
        },
        {
          id: 'payouts',
          icon: 'fa fa-credit-card',
          iconImage: (() => { const m = require('@/assets/images/why-choose-6.png'); return m?.default || m; })(),
          title: 'Quick & Reliable Payouts',
          description: 'Receive your earnings smoothly with reliable payouts after completed appointments.',
        },
      ];

      const p = this.salonPage;
      if (!p) return defaults;

      return [1, 2, 3, 4, 5, 6].map((n, idx) => {
        const d = defaults[idx];
        const iconPath = p[`choose_icon_${n}`];
        const title = p[`choose_heading_${n}`];
        const desc = p[`choose_text_${n}`];
        return {
          id: d.id,
          icon: d.icon,
          iconImage: iconPath && String(iconPath).trim() ? this.$getImageUrl(iconPath) : d.iconImage,
          title: title && String(title).trim() ? title : d.title,
          description: desc && String(desc).trim() ? desc : d.description,
        };
      });
    },
    salonBenefitsLeft() {
      return this.salonBenefits.slice(0, 3);
    },
    salonBenefitsRight() {
      return this.salonBenefits.slice(3, 6);
    },
    salonPaymentsBenefits() {
      const defaults = [
        {
          id: 'handle',
          title: 'We Handle the Payments',
          description: 'LushGroom securely collects payments from clients on your behalf, so you never have to follow up or chase payments.',
        },
        {
          id: 'payouts',
          title: 'Fast Payouts After Service',
          description: 'Once a booking is completed, your earnings are released quickly so you stay focused on running your salon.',
        },
        {
          id: 'pricing',
          title: 'Clear & Transparent Pricing',
          description: 'You receive your listed price minus a small processing fee — similar to standard card charges. Clients pay a separate platform fee for using the LushGroom booking system.',
        },
      ];
      const p = this.salonPage;
      if (!p) return defaults;
      return [1, 2, 3].map((n, idx) => {
        const d = defaults[idx];
        const title = p[`payment_heading_${n}`];
        const desc = p[`payment_text_${n}`];
        return {
          id: d.id,
          title: title && String(title).trim() ? title : d.title,
          description: desc && String(desc).trim() ? desc : d.description,
        };
      });
    },
    whyItems() {
      const defaults = [
        {
          id: 'income',
          title: 'Guaranteed Income',
          description: 'Customers pay upfront, so every confirmed booking means secure, guaranteed earnings.',
        },
        {
          id: 'clients',
          title: 'Reach More Clients',
          description: 'Get instantly connected to a large network of pet owners looking for grooming services.',
        },
        {
          id: 'schedule',
          title: 'Flexible Schedule',
          description: 'Set your own availability and choose when and where you want to work.',
        },
        {
          id: 'safe',
          title: 'Safe & Reliable',
          description: 'Enjoy transparent, hassle-free bookings designed to protect both you and your clients.',
        },
        {
          id: 'marketing',
          title: 'Zero Marketing Costs',
          description: 'Focus on what you do best — grooming — while we handle bringing customers to you.',
        },
      ];
      const p = this.groomerPage;
      if (!p) return defaults;
      return [1, 2, 3, 4, 5].map((n, idx) => {
        const d = defaults[idx];
        const title = p[`why_join_heading_${n}`];
        const desc = p[`why_join_text_${n}`];
        return {
          id: d.id,
          title: title && String(title).trim() ? title : d.title,
          description: desc && String(desc).trim() ? desc : d.description,
        };
      });
    },
    groomerTestimonials() {
      const defaults = [
        {
          id: 't1',
          quote:
            'LushGroom made it easy to get consistent bookings. I love the flexibility — I set my own schedule and still stay fully booked most weeks.',
          name: 'Joanna Davies',
          initials: 'JD',
          role: 'Pet Visitor',
          rating: 5,
        },
        {
          id: 't2',
          quote:
            'The prepaid bookings are a game changer. I don’t chase payments anymore, and the customer flow is steady — especially during peak hours.',
          name: 'Joanna Davies',
          initials: 'JD',
          role: 'Pet Visitor',
          rating: 5,
        },
      ];
      const p = this.groomerPage;
      const reviews = p?.reviews;
      if (reviews && reviews.length) {
        return reviews.map((r, idx) => {
        const name = r.name || '';
        const rating = Number(r.rating);
        return {
          id: r.id != null ? String(r.id) : `r-${idx}`,
          quote: r.text || '',
          name,
          initials: this.nameToInitials(name),
          role: r.post || '',
          rating: rating >= 1 && rating <= 5 ? rating : 5,
        };
        });
      }
      if (p && (p.groomer_say_text || p.groomer_say_name)) {
        const name = p.groomer_say_name || '';
        const rating = Number(p.groomer_say_rating);
        return [
          {
            id: 'legacy-say',
            quote: p.groomer_say_text || '',
            name,
            initials: this.nameToInitials(name),
            role: p.groomer_say_post || '',
            rating: rating >= 1 && rating <= 5 ? rating : 5,
          },
        ];
      }
      return defaults;
    },
    salonSpotlightCards() {
      const defaults = [
        {
          id: 'identity',
          icon: 'fa fa-id-badge',
          iconImage: (() => { const m = require('@/assets/images/grow-icon-1.png'); return m?.default || m; })(),
          title: 'Keep Your Identity',
          description: 'Your salon name, Google, and branding remain completely yours. LushGroom enhances your presence — it never replaces it.',
        },
        {
          id: 'reach',
          icon: 'fa fa-globe',
          iconImage: (() => { const m = require('@/assets/images/grow-icon-2.png'); return m?.default || m; })(),
          title: 'Expand Your Reach',
          description: 'Be featured on LushGroom and connect with thousands of pet owners actively searching for grooming services — no extra marketing required.',
        },
        {
          id: 'rebooking',
          icon: 'fa fa-refresh',
          iconImage: (() => { const m = require('@/assets/images/grow-icon-3.png'); return m?.default || m; })(),
          title: 'Effortless Rebooking',
          description: 'Custom QR codes link directly to your LushGroom profile, making it simple for clients to rebook and explore your services.',
        },
        {
          id: 'choice',
          icon: 'fa fa-sliders',
          iconImage: (() => { const m = require('@/assets/images/grow-icon-4.png'); return m?.default || m; })(),
          title: 'Your Business, Your Choice',
          description: 'Using LushGroom branding is entirely optional. You stay in control — always.',
        },
      ];

      const p = this.salonPage;
      if (!p) return defaults;

      return [1, 2, 3, 4].map((n, idx) => {
        const d = defaults[idx];
        const iconPath = p[`grow_icon_${n}`];
        const title = p[`grow_heading_${n}`];
        const desc = p[`grow_text_${n}`];
        return {
          id: d.id,
          icon: d.icon,
          iconImage: iconPath && String(iconPath).trim() ? this.$getImageUrl(iconPath) : d.iconImage,
          title: title && String(title).trim() ? title : d.title,
          description: desc && String(desc).trim() ? desc : d.description,
        };
      });
    },
    salonTestimonials() {
      const defaults = [
        {
          id: 's1',
          quote:
            'LushGroom brought us consistent bookings without discounting our brand. The prepaid appointments make planning staff and inventory so much easier.',
          name: 'Joanna Davies',
          initials: 'JD',
          role: 'Pet Visitor',
          rating: 5,
        },
        {
          id: 's2',
          quote:
            'We kept our pricing and identity, but gained new clients quickly. The platform is simple, transparent, and the support team is responsive.',
          name: 'Joanna Davies',
          initials: 'JD',
          role: 'Pet Visitor',
          rating: 5,
        },
      ];
      const reviews = this.salonPage?.reviews;
      if (!reviews || !reviews.length) return defaults;
      return reviews.map((r, idx) => {
        const name = r.name || '';
        const rating = Number(r.rating);
        return {
          id: r.id != null ? String(r.id) : `sr-${idx}`,
          quote: r.text || '',
          name,
          initials: this.nameToInitials(name),
          role: r.post || '',
          rating: rating >= 1 && rating <= 5 ? rating : 5,
        };
      });
    },
    defaultFaqList() {
      const commonAnswer =
        'LushGroom is a booking platform that connects groomers and salons with pet owners. You get prepaid bookings, flexible scheduling, and more consistent work without marketing hassle.';
      return [
        { id: 'f1', question: 'How does joining LushGroom work?', answer: commonAnswer },
        { id: 'f2', question: 'Is there any cost to sign up?', answer: 'No. You can apply to join for free. We earn when you earn through confirmed bookings.' },
        { id: 'f3', question: 'Do customers pay upfront?', answer: 'Yes. Bookings are prepaid so your earnings are secure and you don’t have to chase payments.' },
        { id: 'f4', question: 'Can I choose my own schedule?', answer: 'Yes. Set your availability and take bookings that fit your preferred times and locations.' },
        { id: 'f5', question: 'Do I need to have a mobile van?', answer: 'No. You can work in-home, from a home studio, or from a salon—pick the setup that matches you.' },
        { id: 'f6', question: 'How do I get started?', answer: 'Click “Join LushGroom” and contact our team. We’ll verify details and guide you through onboarding.' },
        { id: 'f7', question: 'What areas do you operate in?', answer: 'We operate by country/city. Select your location in the website switcher to see the active service area.' },
        { id: 'f8', question: 'How are bookings assigned?', answer: 'Bookings are matched based on availability, location, and service fit so you can serve clients efficiently.' },
        { id: 'f9', question: 'Can salons partner with LushGroom?', answer: 'Yes. Salons can partner to receive additional appointments during busy periods.' },
        { id: 'f10', question: 'Is support available if I need help?', answer: 'Yes. Our team supports you with booking issues, customer communication, and platform guidance.' },
        { id: 'f11', question: 'What services can I offer?', answer: 'Offer the grooming services you’re qualified for. Your listing can reflect what you provide.' },
        { id: 'f12', question: 'How do I get paid?', answer: 'Since bookings are prepaid, payouts are handled smoothly based on completed appointments.' },
      ];
    },
    applyFaqItems() {
      if (this.isSalon) {
        const apiFaqs = this.salonPage?.faqs;
        if (apiFaqs && apiFaqs.length) {
          return apiFaqs.map((f, idx) => ({
            id: f.id != null ? `sf-${f.id}` : `sf-${idx}`,
            question: f.question,
            answer: f.answer,
          }));
        }
        return this.defaultFaqList;
      }
      const apiFaqs = this.groomerPage?.faqs;
      if (apiFaqs && apiFaqs.length) {
        return apiFaqs.map((f, idx) => ({
          id: f.id != null ? `gf-${f.id}` : `gf-${idx}`,
          question: f.question,
          answer: f.answer,
        }));
      }
      return this.defaultFaqList.slice(0, 6);
    },
    applyFaqColumns() {
      const items = (this.applyFaqItems || []).map((f, idx) => ({ ...f, _idx: idx }));
      const left = [];
      const right = [];
      items.forEach((it, idx) => {
        (idx % 2 === 0 ? left : right).push(it);
      });
      return [left, right];
    },
  },
  methods: {
    nameToInitials(name) {
      if (!name || typeof name !== 'string') return '';
      const parts = name.trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return '';
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    },
    async fetchGroomerPage() {
      if (!this.isGroomer) return;
      try {
        const res = await this.$axios.post('/get-groomer-page', {
          website_name: this.activeWebsiteName,
        });
        this.groomerPage = res?.data?.groomer_page ?? null;
      } catch (e) {
        console.error('fetchGroomerPage', e);
      }
    },
    async fetchSalonPage() {
      if (!this.isSalon) return;
      try {
        const res = await this.$axios.post('/get-salon-page', {
          website_name: this.activeWebsiteName,
        });
        this.salonPage = res?.data?.salon_page ?? null;
      } catch (e) {
        console.error('fetchSalonPage', e);
      }
    },
  },
};
</script>

<style scoped>
.text-lh-large {
  line-height: 1.8;
}

.apply-faq-groomer {
  background-color: #f8f9fa;
}

.apply-hero {
  background: #f5f6f7;
  position: relative;
  overflow: hidden;
}

/* subtle pattern dots like the reference (kept lightweight) */
.apply-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(0, 0, 0, 0.08) 1px, transparent 1px);
  background-size: 26px 26px;
  opacity: 0.25;
  pointer-events: none;
}

.apply-hero-title {
  font-size: 44px;
  line-height: 1.05;
  color: #111;
  position: relative;
  z-index: 1;
}

.apply-hero-desc,
.apply-hero-cta {
  position: relative;
  z-index: 1;
}

.apply-hero-cta {
  padding: 12px 18px;
  border-radius: 6px;
  text-decoration: none;
}

.apply-hero-media {
  width: min(520px, 100%);
  aspect-ratio: 5 / 4;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 1;
}

/* Salon hero as full-width cover background */
.apply-hero-salon-cover {
  background-size: cover;
  background-position: center right;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.apply-hero-salon-cover-content {
  max-width: 520px;
}

/* Tiny heart icons (top-right) like the reference */
.apply-hero-salon-heart {
  position: absolute;
  top: 14px;
  right: 16px;
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.95);
  transform: rotate(45deg);
  border-radius: 2px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
}
.apply-hero-salon-heart::before,
.apply-hero-salon-heart::after {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
}
.apply-hero-salon-heart::before {
  left: -5px;
  top: 0;
}
.apply-hero-salon-heart::after {
  left: 0;
  top: -5px;
}
.apply-hero-salon-heart-2 {
  top: 14px;
  right: 32px;
  opacity: 0.7;
  transform: rotate(45deg) scale(0.9);
}

@media (max-width: 991px) {
  .apply-hero-title {
    font-size: 36px;
  }
}

@media (max-width: 575px) {
  .apply-hero-title {
    font-size: 30px;
  }
  .apply-hero-cta {
    width: 100%;
    text-align: center;
  }
  .apply-hero-salon-cover-content {
    max-width: 100%;
  }
}

.apply-setup {
  background: #f7e9e2;
}

.apply-setup-title {
  font-size: 20px;
  letter-spacing: 0.08em;
  color: #111;
}

.apply-setup-subtitle {
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.9;
}

.apply-setup-card {
  background: #fff;
  border-radius: 10px;
  padding: 18px 16px 16px;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.apply-setup-icon {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: #f3f4f6;
  border: 1px solid rgba(0, 0, 0, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  color: #111;
}

.apply-setup-icon i {
  font-size: 18px;
}

.apply-setup-icon-img {
  width: 45px;
  height: 45px;
  object-fit: contain;
  border-radius: 50%;
}

.apply-setup-desc {
  opacity: 0.85;
}

.apply-setup-foot {
  opacity: 0.85;
}

.apply-setup-cta {
  padding: 12px 20px;
  border-radius: 6px;
  text-decoration: none;
  min-width: 200px;
}

.apply-setup-cta-sub {
  letter-spacing: 0.12em;
  opacity: 0.8;
}

.apply-salon-setup-title {
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.apply-salon-setup-subtitle {
  max-width: 760px;
}

.apply-salon-setup-grid {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
}

.apply-salon-setup-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.apply-salon-benefit {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 6px 4px;
  text-align: left;
}

/* Match reference: outer icons */
.apply-salon-benefit--icon-right {
  flex-direction: row-reverse;
}

.apply-salon-benefit--icon-right .apply-salon-benefit-body {
  text-align: right;
}

.apply-salon-benefit-icon {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #f8721f;
  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.06);
  flex: 0 0 42px;
}

.apply-salon-benefit-icon i {
  font-size: 16px;
}

.apply-salon-benefit-icon-img {
  width: 35px;
  height: 35px;
  object-fit: contain;
  border-radius: 50%;
}

.apply-salon-benefit-body {
  min-width: 0;
}

.apply-salon-benefit-title {
  font-size: 13px;
  margin-bottom: 4px;
}

.apply-salon-benefit-desc {
  font-size: 11px;
  line-height: 1.35;
  opacity: 0.85;
  max-width: 360px;
}

.apply-salon-pay-title {
  font-size: 22px;
  color: #111;
}

.apply-salon-pay-subtitle {
  max-width: 520px;
  opacity: 0.9;
}

.apply-salon-pay-list {
  list-style: none;
}

.apply-salon-pay-item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.apply-salon-pay-bullet {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: rgba(248, 114, 31, 0.12);
  color: #f8721f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 22px;
  margin-top: 2px;
}

.apply-salon-pay-bullet i {
  font-size: 12px;
}

.apply-salon-pay-item-title {
  font-size: 13px;
  margin-bottom: 2px;
}

.apply-salon-pay-item-desc {
  font-size: 11px;
  line-height: 1.35;
  opacity: 0.85;
  max-width: 520px;
}

.apply-salon-pay-visual {
  position: relative;
  width: min(460px, 100%);
  aspect-ratio: 1 / 1;
  display: grid;
  place-items: center;
}

.apply-salon-pay-image {
  position: relative;
  width: 82%;
  height: 82%;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  z-index: 1;
}

.apply-why {
  background: #f5f6f7;
}

.apply-why-title {
  font-size: 22px;
  color: #111;
}

.apply-why-subtitle {
  opacity: 0.9;
}

.apply-why-visual {
  position: relative;
  width: min(520px, 100%);
  margin: 0 auto;
  aspect-ratio: 4 / 3;
}

.apply-why-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  filter: none;
}

.apply-why-list {
  list-style: none;
}

.apply-why-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.apply-why-num {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #f8721f;
  color: #111;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 26px;
  margin-top: 2px;
}

.apply-why-item-title {
  font-size: 13px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.apply-why-item-desc {
  font-size: 12px;
  line-height: 1.35;
  opacity: 0.85;
}

@media (max-width: 575px) {
  .apply-why-visual {
    aspect-ratio: 1 / 1;
  }
}

.apply-say {
  background: #f7e9e2;
  position: relative;
  overflow: hidden;
}

/* light paw pattern overlay */
.apply-say::before {
  content: '';
  position: absolute;
  inset: 0;
  opacity: 0.18;
  pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='220' height='140' viewBox='0 0 220 140'%3E%3Cg fill='none' stroke='%23000000' stroke-opacity='0.35' stroke-width='2'%3E%3Cpath d='M38 52c6 0 10 5 10 10 0 8-6 14-14 14S20 70 20 62c0-5 6-10 18-10z'/%3E%3Ccircle cx='20' cy='40' r='6'/%3E%3Ccircle cx='38' cy='34' r='6'/%3E%3Ccircle cx='56' cy='40' r='6'/%3E%3Ccircle cx='50' cy='24' r='5'/%3E%3Cpath d='M160 108c6 0 10 5 10 10 0 8-6 14-14 14s-14-6-14-14c0-5 6-10 18-10z'/%3E%3Ccircle cx='142' cy='96' r='6'/%3E%3Ccircle cx='160' cy='90' r='6'/%3E%3Ccircle cx='178' cy='96' r='6'/%3E%3Ccircle cx='172' cy='80' r='5'/%3E%3C/g%3E%3C/svg%3E");
  background-size: 240px 160px;
  background-repeat: repeat;
}

.apply-say-title {
  font-size: 18px;
  color: #111;
}

.apply-say-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 18px 16px;
  box-shadow: 0 16px 35px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 1;
}

.apply-say-quote {
  opacity: 0.9;
  min-height: 72px;
}

.apply-say-avatar {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #111;
  font-weight: 800;
  font-size: 12px;
  background: #f1f5f9;
  border: 2px solid #fff;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.08);
}

.apply-say-role {
  opacity: 0.7;
}

.apply-say-stars {
  color: #f6b73c;
  font-size: 12px;
  letter-spacing: 1px;
}

.apply-salon-say {
  background: #f5f6f7;
}

.apply-salon-say-title {
  font-size: 16px;
  color: #111;
}

.apply-salon-say-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 18px 16px;
  box-shadow: 0 16px 35px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.apply-salon-say-quote {
  opacity: 0.9;
  min-height: 72px;
}

.apply-salon-say-avatar {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #111;
  font-weight: 800;
  font-size: 12px;
  background: #f1f5f9;
  border: 2px solid #fff;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.08);
}

.apply-salon-say-role {
  opacity: 0.7;
}

.apply-salon-say-stars {
  color: #f6b73c;
  font-size: 12px;
  letter-spacing: 1px;
}

.apply-salon-spot-title {
  font-size: 18px;
  letter-spacing: 0.08em;
  color: #111;
}

.apply-salon-spot-subtitle {
  max-width: 760px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.9;
}

.apply-salon-spot-grid {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
}

.apply-salon-spot-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px 14px;
  box-shadow: 0 16px 35px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.apply-salon-spot-icon {
  width: 46px;
  height: 46px;
  border-radius: 999px;
  background: #f1f5f9;
  border: 1px solid rgba(0, 0, 0, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  color: #f8721f;
}

.apply-salon-spot-icon i {
  font-size: 18px;
}

.apply-salon-spot-icon-img {
  width: 45px;
  height: 45px;
  object-fit: contain;
  border-radius: 50%;
}

.apply-salon-spot-card-title {
  font-size: 12px;
  margin-bottom: 6px;
}

.apply-salon-spot-card-desc {
  font-size: 11px;
  line-height: 1.35;
  opacity: 0.85;
}


</style>
